/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/-/blob/07456af8b2b7090b0ed8294c58737da301e2468b/frontend/CID/poski/v26.2/easy-v5/js/nemovitost-4-views.js */
// Načítání virtuální prohlídky a videoprohlídky
const inicializedVideoPlayers = new Set();
window.stopAllPlayers = function (excludeElement) {
    const players = document.querySelectorAll(".view-player");
    players.forEach(player => {
        if (excludeElement && (player === excludeElement || player.contains(excludeElement))) {
            return;
        }

        const iframe = player.querySelector("iframe");
        if (iframe) {
            if (iframe.src.indexOf("autoplay=1") !== -1) {
                const src = iframe.src;
                iframe.src = "";
                iframe.src = src;
            }
        }

        const video = player.querySelector("video");
        if (video) {
            video.pause();
        }
    });
};

function loadPlayer(el) {
    const {type, id} = el.dataset;
    if (inicializedVideoPlayers.has(el)) {
        return;
    }
    inicializedVideoPlayers.add(el);
    const playerTypes = {
        matterport: () => {
            const isMatterport = /matterport\.com/i.test(id);
            if (!isMatterport) {
                return createIframe(id);
            }
            return createIframe(getMatterportUrlWithPlay(id));
        },
        youtube: () => createIframe(`https://www.youtube.com/embed/${id}?autoplay=1`),
        video: () => createVideo(id)
    };
    if (playerTypes[type]) {
        el.innerHTML = "";
        el.appendChild(playerTypes[type]());
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".view-player").forEach(el => {
        el.addEventListener("click", () => loadPlayer(el));
    });
});

function getMatterportUrlWithPlay(src) {
    if (typeof src !== "string") {
        return src;
    }

    const normalized = src.trim().replace(/\/+$/, "");
    if (normalized === "") {
        return normalized;
    }

    const hasPlayParam = /([?&])play=1(&|$)/.test(normalized);
    if (hasPlayParam) {
        return normalized;
    }

    const separator = normalized.includes("?") ? "&" : "?";
    return `${normalized}${separator}play=1`;
}

function createIframe(src) {
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.frameBorder = "0";
    iframe.allowFullscreen = true;
    iframe.allow = "autoplay; encrypted-media";
    return iframe;
}

function createVideo(src) {
    const video = document.createElement("video");
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    return video;
}
